
<div 
  #swiper
  class="register-user-form__container"
>
  <ul class="register-user-form__items swiper-wrapper">
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-date-field
          [form]="form()"
          formControlNameStartDate="startDate"
          formControlNameEndDate="endDate"
          [isNextButtonClicked]="isNextButtonClicked()"
        />
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <header class="register-user-form__header">
          <h2 class="register-user-form__title ci-heading-h2-s-bold">
            {{ 'Datos del viaje' | translate }}
          </h2>
          
          <span class="ci-paragraph-p1-regular register-user-form__subtitle">
            {{ 'Añade más información opcional sobre el viaje para personalizar aún más tu ruta' | translate }}
          </span>
        </header>
        
        <main class="register-user-form__main">
          <app-time-fields
            [form]="form()"
            formControlNameStartTime="startTime"
            formControlNameEndTime="endTime"
          />
          
          <app-movility-field
            [form]="form()" 
            formControlName="movilityType"
          />

          <app-location-field
            [form]="form()" 
            formControlName="startLocationAddress"
            [isNextButtonClicked]="isNextButtonClicked()"
          />  
        </main>
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-trip-types-field
          [form]="form()" 
          formControlName="tripType"
          [isNextButtonClicked]="isNextButtonClicked()"
        />
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-interests-field
          [form]="form()" 
          formControlName="interestIdList"
          [isNextButtonClicked]="isNextButtonClicked()"
        />
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-transport-means-field
          [form]="form()" 
          formControlName="transportMeans"
          [isLastSlideValidationActive]="isLastSlideValidationActive()"
        />
        
        <app-max-distance-field
          [form]="form()" 
          formControlName="maxDistanceWalking"
        />
      </article>
    </li>
  </ul>
  
  <div class="swiper-pagination"></div>
  
  <ci-text-button
    class-name="ci-text-btn-primary-s"
    class="register-user-form__prev-button"
    (click)="goToPrevSlide()"
    [disabled]="!canGoPrev()"
  >
    {{ 'Volver' | translate }}
  </ci-text-button>
  
  <ci-button
    [class-name]="canGoNext() ? 'ci-btn-primary-s-filled' : 'ci-btn-primary-s-disabled'"
    class="register-user-form__next-button"
    [disabled]="!canGoNext()"
    (click)="isLastSlide() ? handleLastSlideClick() : goToNextSlide()"
  >
    {{ 'Continuar' | translate }}
  </ci-button>
</div>